import { TypographyTooltip } from 'pages/Representatives/components/TypographyTooltip';
import { useState } from 'react';
import {
  EditProfileDocumentsVideoItemDetailsContainer,
  EditProfileDocumentsVideoItemIconContainer,
  EditProfileDocumentsVideoItemWrapper,
} from './EditProfileMediaDocumentVideoItem.styles';
import { EditProfileCustomSkeleton, EditProfileDragContainer, EditProfileNumberBox } from '../../../EditProfile.styles';
import { EttachedHiddenType } from 'shared/enums/EAttachedHiddenType';
import { Checkbox, IconButton } from '@material-ui/core';
import { HideIcon, Move } from '@room-match/shared-ui-components';
import { formatTime } from 'shared/utils/formatTime';
import { useEditProfileDndControls } from '../../../hooks/useEditProfileDndControls';
import ReactPlayer from 'react-player';
import PlayButtonIcon from 'shared/elements/PlayButtonIcon/PlayButtonIcon';
import { EditProfileMediaCheckBoxContainer } from '../../EditProfileMedia/EditProfileMedia.styles';

type EditProfileMediaDocumentVideoItemProps = {
  url: string;
  fileName?: string;
  onHideClick?: VoidFunction;
  index?: number;
  type: EttachedHiddenType;
  id: string;
};

const EditProfileMediaDocumentVideoItem = ({
  url,
  fileName,
  index,
  onHideClick,
  type = EttachedHiddenType.ATTACHED,
  id,
}: EditProfileMediaDocumentVideoItemProps) => {
  const { attributes, listeners, style, setNodeRef, onMobile } = useEditProfileDndControls(id);

  const [duration, setDuration] = useState<number | null>(null);
  const [playing, setPlaying] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);

  const isOptmisicallyUpdating = fileName?.includes('skeleton-optimistic-updating-list');

  const handlePlay = () => {
    setPlaying((prev) => !prev);
  };

  return (
    <div ref={setNodeRef} style={{ ...style, marginBottom: 20, position: 'relative' }}>
      <EditProfileDocumentsVideoItemWrapper
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {isOptmisicallyUpdating || !videoLoaded ? (
          <EditProfileCustomSkeleton variant="rect" height={'100%'} width={'100%'} />
        ) : null}

        <ReactPlayer
          url={url}
          playing={playing}
          onEnded={() => handlePlay()}
          onDuration={(d) => setDuration(d)}
          controls={playing}
          width="100%"
          height="100%"
          style={{ display: isOptmisicallyUpdating || !videoLoaded ? 'none' : 'block' }}
          onReady={() => setVideoLoaded(true)}
        />

        {!playing && (
          <EditProfileDocumentsVideoItemIconContainer onClick={handlePlay}>
            <PlayButtonIcon />
          </EditProfileDocumentsVideoItemIconContainer>
        )}
        <EditProfileNumberBox style={type === EttachedHiddenType.HIDDEN ? { background: 'unset' } : {}}>
          {isHovered && type === EttachedHiddenType.ATTACHED && !isOptmisicallyUpdating ? (
            <IconButton style={{ padding: 0 }}>
              <HideIcon onClick={onHideClick} />
            </IconButton>
          ) : type === EttachedHiddenType.HIDDEN ? (
            <EditProfileMediaCheckBoxContainer onClick={onHideClick}>
              <Checkbox checked={false} />
            </EditProfileMediaCheckBoxContainer>
          ) : (
            index
          )}
        </EditProfileNumberBox>
        {(isHovered || onMobile) && type === EttachedHiddenType.ATTACHED && !isOptmisicallyUpdating ? (
          <EditProfileDragContainer {...attributes} {...listeners}>
            <Move viewBox="0 0 16 16" />
          </EditProfileDragContainer>
        ) : null}
      </EditProfileDocumentsVideoItemWrapper>

      {isOptmisicallyUpdating ? null : (
        <EditProfileDocumentsVideoItemDetailsContainer>
          {fileName ? (
            <TypographyTooltip variant="subtitle2" style={{ flex: 1 }}>
              {fileName}
            </TypographyTooltip>
          ) : null}
          <TypographyTooltip
            style={{ textAlign: 'end', width: 'fit-content' }}
            variant="subtitle2"
          >{`Duration: ${duration !== null ? formatTime(duration) : '---'}`}</TypographyTooltip>
        </EditProfileDocumentsVideoItemDetailsContainer>
      )}
    </div>
  );
};

export default EditProfileMediaDocumentVideoItem;
